function initLocationSearchSuggestions() {
    const options = {};

    if (
        typeof wpslSettings.geocodeComponents !== "undefined" &&
        !jQuery.isEmptyObject(wpslSettings.geocodeComponents)
    ) {
        options.componentRestrictions = wpslSettings.geocodeComponents;

        /**
         * If the postalCode is included in the autocomplete together with '(regions)' ( which is included ),
         * then it will break it. So we have to remove it.
         */
        options.componentRestrictions = _.omit(
            options.componentRestrictions,
            "postalCode",
        );
    }

    // Check if we need to restrict the autocomplete data.
    if (
        typeof wpslSettings.autoCompleteOptions !== "undefined" &&
        !jQuery.isEmptyObject(wpslSettings.autoCompleteOptions)
    ) {
        for (var key in wpslSettings.autoCompleteOptions) {
            if (wpslSettings.autoCompleteOptions.hasOwnProperty(key)) {
                options[key] = wpslSettings.autoCompleteOptions[key];
            }
        }
    }

    document.querySelectorAll(".location-search-input").forEach((searchInput) => {
		autocomplete = new google.maps.places.Autocomplete(searchInput, options);
    });
}

if (typeof window.wpslAddons !== "object") {
	window.wpslAddons = {};
}

window.wpslAddons.arcadianLocationSearchSuggestions = {
	init: initLocationSearchSuggestions,
};